import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getNewBulkOperation = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.newbulkoperation'],
);

export const getHeader = createSelector(getLiteralsState, ({ literals }) => literals['system.dataimport.header']);

export const getBulkHistory = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.bulkoperations.history'],
);

export const getConfigurationName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.configurationname'],
);

export const getProfileModel = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.profilemodel'],
);

export const getImportConfigurationDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.import.description'],
);

export const getSupportedFile = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.supportedfile'],
);

export const getIntegrationStatus = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.integrations.integrationstatus'],
);

export const getIntegrationsActive = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.integrations.filter.active'],
);

export const getBulkStatus = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.importhistory.status'],
);

export const getBulkImportDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.importhistory.importdate'],
);

export const getBulkInProgress = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.bulkoperations.history.inprogressoption'],
);

export const getBulkAll = createSelector(getLiteralsState, ({ literals }) => literals['liquid.search.filters.all']);

export const getTotalLinesImport = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.importhistory.totallinesforimport'],
);

export const getImportDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.importhistory.importdate'],
);

export const getConfig = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.configuration'],
);

export const getErrorsFound = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.errorsfound'],
);

export const getLogId = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.bulkoperations.history.logid'],
);

export const getLogDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.transactions.log_date'],
);

export const getLogMessage = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.bulkoperations.history.logmessage'],
);

export const getLogDateChanged = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.coupons.log_date'],
);

export const getChooseProfileModel = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.chooseprofilemodel'],
);

export const getMapFileData = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.mapfiledata'],
);

export const getSaveBulkConfiguration = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.saveconfiguration'],
);

export const getAddNewConfigurationDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.configurationdescription'],
);

export const getStartNewBulkOperationQuestion = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.startnewbulkoperationquestion'],
);

export const getFileType = createSelector(getLiteralsState, ({ literals }) => literals['liquid.dataimport.filetype']);

export const getFileName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.supportedpattern'],
);

export const getDataDelimiter = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.datadelimiter'],
);

export const getFirstLineContainsHeader = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.filefirstlinecontainsheader'],
);

export const getChooseFile = createSelector(
  getLiteralsState,
  ({ literals }) => literals['member.utilities.import.choose'],
);

export const getDragAndDropFile = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.draganddropafilehere'],
);

export const getOR = createSelector(getLiteralsState, ({ literals }) => literals['member.utilities.import.or']);

export const getDataMap = createSelector(getLiteralsState, ({ literals }) => literals['liquid.dataimport.datamap']);

export const getProfileModelKey = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.profilemodelkey'],
);

export const getAdvancedMappingOptions = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.advancedmappingoptions'],
);

export const getChooseAnotherFile = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.chooseanotherfile'],
);

export const getFlowName = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.name']);

export const getAttributeMappingRules = createSelector(
  getLiteralsState,
  ({ literals }) => literals['help.dataimport.attributemappingrules'],
);

export const getBulkConfiguration = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.configuration'],
);

export const getBulkGroupName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.businessgroup.name'],
);

export const getBulkDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.results.description'],
);

export const getBulkFilesFirstLine = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.filefirstline'],
);

export const getBulkFile = createSelector(getLiteralsState, ({ literals }) => literals['liquid.system.file.chosen']);

export const getFileNumberOfLines = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.filenumberoflines'],
);

export const getExecute = createSelector(getLiteralsState, ({ literals }) => literals['liquid.dataimport.execute']);

export const getConfigurationSaved = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.configurationsaved'],
);

export const getKeyNotMapped = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.bulk.actions.key.not.mapped'],
);

export const getUserSure = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.checkbook.group.deactivate.areyousure'],
);

export const getDeactivateConfigMessage = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.dataimport.deactivateconfiguration'],
);

export const getNotificationEmail = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.integrations.neverbounce.notificationemail'],
);
